module.exports = __webpack_public_path__ + "img/199.hand_dryer.d982b24c.svg";